import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { TreeData } from 'element-ui/types/tree';

import { types } from './types';
import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	PracovnikOzn: null as string | null,
	Text: null as string | null,
	ZaznamId: null as number | null,
	MainMenus: [],
	SubMenus: [],
	SelectedOperations: [],
	SelectedTabs: [],
	SelectedOperation: [],
	MenuOperations: [],
	MenuTabs: [],
	MenuIds: [],
	TabIds: [],
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		EmailTypPzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {
		dataChecked: [] as number[],
		menuTree: [] as { Id: number, SubMenuId: number, Text: string, children: any[] }[],
		subMenuTree: [] as { Id: number, SubMenuId: number, Text: string, children: TreeData[] }[],
		selectedOperations: [] as number[],
		selectedTabs: [] as number[],
		menuOperations: [] as { Id: number, SubMenuId: number, Text: string, children: TreeData[] }[],
		menuTabs: [] as { Id: number, SubMenuId: number, Text: string, children: TreeData[] }[],
	},
	extraActions: {
		[types.actions.GET_ROLE_TREE_VIEW]: async ({ state, commit, dispatch }) => {
			const { data } = await apiProvider.getRoleBaseMenuList(state.edit.ZaznamId!);
			state.edit.MainMenus = data.MainMenus;
			state.edit.SubMenus = data.SubMenus;
			state.edit.MenuOperations = data.MenuOperations;
			state.edit.MenuTabs = data.MenuTabs;
			state.edit.SelectedOperations = data.SelectedOperations;
			state.edit.SelectedTabs = data.SelectedTabs;
		},
	},
	extraMutations: {
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
